import { environment } from '@environment';
import { AbstractAuthService } from 'core/models/auth-service';
import { SmartcardSurnameResponse, UserAuth } from 'core/stores/auth/auth-types';
import { AuthUtils } from 'core/stores/auth/auth-utils';
import { SiteConfigStore } from 'core/stores/site-config.store';
import { EndpointHelper } from './endpoint.helper';
import { HttpClient } from './http';

export class AuthSmartcardService implements AbstractAuthService {
  hasRefresh = true;

  readonly apiBuilder = new EndpointHelper(`${environment.MAH_API_BASE_URL}/${environment.MAH_API_LOGIN}/${environment.MAH_API_VERSION}`);

  login(user: UserAuth) {
    if (!user.loginReq) {
      return Promise.reject('Cannot login')
    }

    const url = this.apiBuilder.createUrl('Login')
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .build();

    return HttpClient.GetInstance.post<any, SmartcardSurnameResponse>(url, user.loginReq)
      .then(res => AuthUtils.MapSmartcardSurnameResponse(res.data))
  }

  refreshToken(user: UserAuth) {
    const url = this.apiBuilder.createUrl('RefreshToken').build();

    return HttpClient.GetInstance.get<any>(url)
      .then(res => {
        const refreshedUser = AuthUtils.MapSmartcardSurnameResponse(res.data);

        if (!refreshedUser?.auth?.accessToken) {
          return Promise.reject('Unable to refresh session');
        }

        return { ...user, ...refreshedUser };
      })
  }

  signInUrl() {
    throw Error(`AuthSmartcardService -> signInUrl not implemented`);
  }

  registerUrl() {
    throw Error(`AuthSmartcardService -> registerUrl not implemented`);
  }

  logout() {
    // TODO: implement logout logic.
  }
}